import React from "react";
import { useForm, useFormState } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import { Button, Paper, Stack } from "@mui/material";
import { TaxType } from "@soqs/common";
import BOEntityRepDetails from "./BOEntityRepDetails";
const BOEntityRepList = (props) => {
  const formstate = useFormState();
  let form = useForm();

  return (
    <>
      <Stack spacing={2} direction={"row"}>
        <Button
          name="AddEntityRep"
          variant="contained"
          color="primary"
          onClick={() => {
            const arrayName = `bo_entities[${props.index}].bo_entity_representatives`;
            form.mutators.unshift(arrayName, {
              bo_entity_representative_key: Date.now().toString(),
              bo_entity_representative_sorted: false,
              bo_entity_representative_collapsed: false,
              bo_entity_representative_botype: 1, //Founder
              bo_entity_representative_idtype: "1", //SA ID
              bo_entity_representative_taxtype: TaxType.PIT,
              bo_entity_representative_country: "ZAF",
              bo_entity_representative_mobilecode: "27",
              bo_entity_representative_passportcountry: "ZAF",
              bo_entity_representative_placeofbirth: "ZAF",
              bo_entity_representative_taxjuristiction: "ZAF",
              // bo_entity_representative_idnumber: "7307225247081",
              // bo_entity_representative_taxnumber: "2819071842",
              bo_entity_representative_passportdt: "2010/01/01",
              /* bo_entity_representative_name: "william",
            bo_entity_representative_surname: "blackwell",
            bo_entity_representative_mobile: "0834553307",
            bo_entity_representative_email: "wblackwell@sars.gov.za",
            bo_entity_representative_unitno: "52",
            bo_entity_representative_complexname: "",
            bo_entity_representative_streetname: "Granite Road",
            bo_entity_representative_suburb: "Witkoppen Ext 6",
            bo_entity_representative_city: "Johannesburg",
            bo_entity_representative_postalcode: "2091", */
              bo_entity_representative_unnamed_category: undefined,
              bo_entity_representative_unnamed_description: "",
              bo_entity_representative_unnamed: false,
            });
          }}
          disabled={
            formstate.values?.bo_entities[props.index]
              ?.bo_entity_representatives?.length >= 3
          }
        >
          Add Named Beneficial Owner
        </Button>
        <Button
          name="AddUnnamedEntityRep"
          variant="contained"
          color="primary"
          onClick={() => {
            const arrayName = `bo_entities[${props.index}].bo_entity_representatives`;
            form.mutators.unshift(arrayName, {
              bo_entity_representative_key: Date.now().toString(),
              bo_entity_representative_sorted: false,
              bo_entity_representative_collapsed: false,    
              bo_entity_representative_unnamed_description: "",
              bo_entity_representative_unnamed: true,
              bo_entity_representative_unnamed_category: undefined,
            });
          }}
          disabled={
            formstate.values?.bo_entities[props.index]
              ?.bo_entity_representatives?.length >= 3
          }
        >
          Add Unnamed Beneficial Owner
        </Button>
      </Stack>
      <br />
      <FieldArray
        name={`bo_entities[${props.index}].bo_entity_representatives`}
      >
        {({ fields }) =>
          fields.map((data, index) => (
            <div key={fields.value[index].bo_entity_representative_key}>
              <br />
              <Paper
                variant="outlined"
                style={{ padding: "2%", paddingTop: "0%" }}
              >
                {
                  <BOEntityRepDetails
                    name={data}
                    index={index}
                    entityindex={props.index}
                  />          
                }
                <br />
                <Button
                  name="deleterepresentative"
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    fields.remove(index);
                  }}
                >
                  Remove Representative
                </Button>
              </Paper>
            </div>
          ))
        }
      </FieldArray>
    </>
  );
};

export default BOEntityRepList;
